// src/components/categories/SideMenu.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useCategories } from '../../context/CategoryContext';

const SideMenuContainer = styled.div`
  width: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  position: sticky;
  top: 20px; // Adjust this value based on your header height
  max-height: calc(100vh - 40px); // Subtract twice the top value
  overflow-y: auto; // Add scrollbar if content is too long
  @media (max-width: 767px) {
    display: none;
  }
`;

const CategoryTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  text-transform: uppercase;
  border-bottom: 2px solid #4CAF50;
  padding-bottom: 10px;
`;

const CategoryList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const CategoryItem = styled.li`
  margin-bottom: 12px;
`;

const CategoryLink = styled(Link)`
  text-decoration: none;
  color: #555;
  font-size: 15px;
  display: block;
  padding: 8px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    color: #4CAF50;
    background-color: #f0f0f0;
  }
`;

const SideMenu = () => {
  const { categories, loading } = useCategories();

  if (loading) {
    return <SideMenuContainer>Loading categories...</SideMenuContainer>;
  }

  return (
    <SideMenuContainer>
      <CategoryTitle>Categories</CategoryTitle>
      <CategoryList>
        {categories.map((category) => (
          <CategoryItem key={category.id}>
            <CategoryLink to={`/categories/${category.slug}`}>
              {category.name}
            </CategoryLink>
          </CategoryItem>
        ))}
      </CategoryList>
    </SideMenuContainer>
  );
};

export default SideMenu;